export default {
  en: {
    description:
      'The Old Assyrian Research Environment (OARE – /’ôrə/) is a poly-hierarchical XML database focused on the documentary corpus of the Old Assyrian trade. The purpose of the database is to facilitate work with the Old Assyrian texts from the period of Kültepe Level II and Kültepe Level Ib. OARE is organized to record both textual and archaeological data, and expert observations arising from the interpretation of both sets of evidence. OARE is designed to facilitate collaborative research projects on the historical and archaeological record of the Old Assyrian trade and society through linguistic, lexical, economic, social, and other lenses.',
    ochre:
      'The OARE database is part of the Online Cultural and Historical Research Environment (OCHRE). Manuals for OCHRE and further information are available at {ochreHref}.',
    enterSite: 'Enter the site',
    createdOare: 'Edward Stratford created OARE within the OCHRE platform.',
    director: 'Director: Edward Stratford',
    editorialBoard:
      'Editorial Board: Gojko Barjamovic, Hakan Erol, and Edward Stratford.',
    thanks:
      'OARE graciously thanks the following organizations for previous and/or ongoing support:',
    contact: 'CONTACT',
  },
  tr: {
    description:
      'Eski Asur Araştırma Ortamı (OARE - / ’ôrə /), Eski Asur ticaretinin belgesel topluluğuna odaklanan çok hiyerarşik bir XML veritabanıdır. Veritabanının amacı Kültepe Seviye II ve Kültepe Seviye Ib döneminden Eski Asur metinleri ile çalışmayı kolaylaştırmaktır. OARE, hem metinsel hem de arkeolojik verileri ve her iki kanıt kümesinin yorumlanmasından kaynaklanan uzman gözlemleri kaydetmek için düzenlenmiştir. OARE, Dilbilimsel, sözlüksel, ekonomik, sosyal ve diğer objektifler aracılığıyla Eski Süryani ticaretinin ve toplumunun tarihsel ve arkeolojik kayıtları üzerine ortak araştırma projelerini kolaylaştırmak için tasarlanmıştır.',
    ochre:
      'OARE veritabanı, Çevrimiçi Kültürel ve Tarihi Araştırma Ortamının (OCHRE) bir parçasıdır. OCHRE kılavuzları ve daha fazla bilgi için: {ochreHref}',
    enterSite: 'Siteye girin',
    createdOare: "Edward Stratford, OCHER platformu içinde OARE'i yarattı.",
    director: 'Yönetmen: Edward Stratford',
    editorialBoard:
      'Yayın Kurulu: Gojko Barjamovic, Hakan Erol ve Edward Stratford.',
    thanks:
      'OARE, önceki ve / veya sürekli destek için aşağıdaki kuruluşlara teşekkür eder:',
    contact: 'İLETİŞİM',
  },
};
